export enum PatientStatus {
  Active = "active",
  Inactive = "inactive",
  Discharged = "discharged",
}

export enum CarePlanStatus {
  Draft = "draft",
  Active = "active",
  Completed = "completed",
  Cancelled = "cancelled",
}

export enum GoalStatus {
  NotStarted = "not_started",
  InProgress = "in_progress",
  Achieved = "achieved",
  NotAchieved = "not_achieved",
}

export enum RiskZone {
  Red = "red",
  Yellow = "yellow",
  Green = "green",
  Gray = "gray",
}

export enum WorkspaceMode {
  Assessment = "assessment",
  Planning = "planning",
  Implementation = "implementation",
  Evaluation = "evaluation",
}

export enum TrendDirection {
  Up = "up",
  Down = "down",
  Stable = "stable",
}

export enum SocialRiskLevel {
  High = "high",
  Moderate = "moderate",
  Low = "low",
  None = "none",
}

export enum InsightPriority {
  Critical = "critical",
  High = "high",
  Medium = "medium",
  Low = "low",
}

// System-recommended escalation urgency on a Protocol Opportunity (T32).
export type UrgencyLevel = "routine" | "urgent" | "emergent";

export enum TimelineEventType {
  Assessment = "assessment",
  VitalReading = "vital_reading",
  MedicationChange = "medication_change",
  CarePlanUpdate = "care_plan_update",
  ContactNote = "contact_note",
  LabResult = "lab_result",
  Hospitalization = "hospitalization",
  Referral = "referral",
}

export enum DocumentationStatus {
  Draft = "draft",
  InReview = "in_review",
  Finalized = "finalized",
}

export enum NotificationType {
  Alert = "alert",
  Reminder = "reminder",
  Task = "task",
  System = "system",
  Message = "message",
}

export enum NotificationPriority {
  Urgent = "urgent",
  High = "high",
  Normal = "normal",
  Low = "low",
}

export enum MeasureCategory {
  HEDIS = "hedis",
  Stars = "stars",
  Custom = "custom",
}

export enum ComplianceStatus {
  Met = "met",
  NotMet = "not_met",
  Pending = "pending",
  Excluded = "excluded",
}

export enum ConsentStatus {
  Consented = "consented",
  Pending = "pending",
  Declined = "declined",
  Expired = "expired",
}
